export default {
    'invoice-no': 'رقم الفاتورة',
    new: 'جديد',
    delete: 'حذف',
    account: 'الحساب',
    'invoice-date': 'تاريخ الفاتورة',
    warehouse: 'المستودع',
    document: 'المستند',
    'net-invoice': 'صافي الفاتورة',
    save: 'حفظ',
    edit: 'تعديل',
    not: 'غير',
    posted: 'مُرحّلة',
    'add-invoice': 'إضافة فاتورة',
    create: 'إنشاء',
    cancel: 'إلغاء',

    'delete-entry': 'حذف سطر',
    'are-you-sure-you-want-to-delete-the-entry': 'هل أنت متأكد من حذف السطر؟',
    
    'delete-invoice': 'حذف الفاتورة',
    'are-you-sure-you-want-to-delete-the-invoice-that-will-delete-the-associated-bond': 'هل أنت متأكد من حذف الفاتورة سيتم حذف السند المُرتبط أيضاً؟',
    notes: 'ملاحظات',
    'account-trade-config': 'حساب المبيعات',
    'invoice-category': 'نمط الفاتورة',
    discount: 'الحسم',
    total: 'الإجمالي',

    headers: {
        no: 'الرقم',
        warehouse: 'المستودع',
        material: 'المادة',
        quantity: 'الكمية',
        count: 'العدد',
        price: 'السعر',
        'discount-percentage': 'نسبة الحسم',
        'discount': 'الحسم',
        'after-discount': ' صافي القيمة',
        'notes': 'الملاحظات',
        'delivery-status': 'حالة التسليم'
    },

    'context-menu': {
        edit: 'تعديل',
        delete: 'حذف'
    },
    receivables: 'المقبوضات',
    'expenses': 'المصاريف',
    'total-expenses': 'المصاريف',
    'total-receipts': 'مجموع المقبوضات',
    'alert-message': 'رسالة تنبيه',
    'confirm-message': 'أصبح مجموع المقبوضات أكبر من الإجمالي. هل تريد المتابعة ؟',
    'change-from-cash-to-debt':'هل أنت متأكد من تغيير نمط دفع الفاتورة؟ مع العلم أنه سيتم استبدال جميع المقيوضات السابقة ب مقبوضة واحدة بقيمة صافي الفاتورة',
    'change-from-debt-to-cash': 'هل أنت متأكد من تغيير نمط دفع الفاتورة؟ مع العلم انه سيتم حذف جميع المقبوضات السابقة',
    'payment-type': 'نمط الدفع',
    'payment-type-alert':'تغيير نمط الدفع',
    'all-categories': 'الكل',
    'cash': 'نقدية',
    'debt': 'آجلة',
    'export-receipt-bond': 'تصدير إيصال قبض',
}